const ROUTING = {
  BLANK: "/",
  ACCESS_DENIED: "/access-denied",
  LOGIN: "/login",
  CAMPAIGN_CHANNEL: "/client/:clientId/campaign/:campaignId?/channel",
  CAMPAIGN: "/client/:clientId?/campaign/:campaignId?",
  CAMPAIGN_BUILDER: "/client/:clientId/campaign/:campaignId/builder",
  CAMPAIGN_DETAILS: "/client/:clientId/campaign/:campaignId/details",
  CAMPAIGN_AUDIENCE: "/client/:clientId/campaign/:campaignId/audience",
  SUBMIT: "/client/:clientId/campaign/:campaignId/submit",
  SUCCESS: "/client/:clientId/campaign/:campaignId/success",
  FLYER: "/client/:clientId/flyer/:campaignId?",
  FLYER_BUILDER_TEMPLATE: "/client/:clientId/flyer/:campaignId?/templates",
  FLYER_BUILDER: "/client/:clientId/flyer/:campaignId?/builder/:format?",
  PUBLIC_FLYER_BUILDER_TEMPLATE: "/design/:countryCode/:roomId",
  PUBLIC_FLYER_BUILDER: "/design/:countryCode/:roomId/:format/builder",
  PUBLIC_FLYER_BUILDER_NEW: "/design/:countryCode/:roomId/builder",
  UPLOAD_DESIGN: "/design-upload/:clientId",
  UPLOAD_FLYER: "/client/:clientId/flyer/:campaignId?/upload/:hideUploadedFile?",
  ERROR: "/error",
  // OAuth handover landing pages — popup window receives the redirect
  // from oppizi-auth (with `source=campaign-builder`) and posts the data
  // back to its opener (the SignupModal in the main builder tab).
  OAUTH_SOCIAL_SIGNUP: "/auth/social/signup",
  OAUTH_SOCIAL_CALLBACK: "/auth/social/callback",
  CREATIVE: "/client/:clientId/flyer/:campaignId?/creative/creative-design",
  SELECT_TEMPLATE: "/client/:clientId/flyer/:campaignId?/creative/creative-design/templates/:format",
};

export const EDDM_ROUTING = {
  EDDM_CAMPAIGN: "/client/:clientId?/eddm/campaign/:campaignId?",
  EDDM_CAMPAIGN_DETAILS: "/client/:clientId/eddm/campaign/:campaignId/details",
  EDDM_CAMPAIGN_SEGMENTS: "/client/:clientId/eddm/campaign/:campaignId/segments",
  EDDM_SUBMIT: "/client/:clientId/eddm/campaign/:campaignId/submit",
  EDDM_SUCCESS: "/client/:clientId/eddm/campaign/:campaignId/success",
  EDDM_FLYER_BUILDER_TEMPLATE: "/client/:clientId/eddm/flyer/:campaignId?/templates",
  EDDM_FLYER_BUILDER: "/client/:clientId/eddm/flyer/:campaignId?/builder",
  EDDM_FLYER: "/client/:clientId/eddm/flyer/:campaignId?",
  EDDM_UPLOAD_FLYER: "/client/:clientId/eddm/flyer/:campaignId?/upload",
};

export const ADM_ROUTING = {
  ADM_CAMPAIGN: "/client/:clientId?/adm/campaign/:campaignId?",
  ADM_CAMPAIGN_BUILDER: "/client/:clientId/adm/campaign/:campaignId/builder/:step?",
  ADM_CAMPAIGN_BUILDER_V2: "/client/:clientId/adm/campaign/:campaignId/builder-v2/:step?",
};

export const SETTINGS = {
  SETTINGS: "/settings",
  SETTINGS_DYNAMIC_COUPONS_QR: "/settings/dynamic-coupons-qr",
};

export default ROUTING;
